import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTable, DataTableBody, DataTableCell, DataTableRow } from "@insite/mobius/index";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumbersStyles {
    dataTableCellStyle?: DataTableCellProps;
    dataTableCellLabelStyle?: DataTableCellProps;
}

export const pageTitleStyles: ProductDetailsPartNumbersStyles = {
    dataTableCellStyle: {
        css: css`
            border: none;
            background-color: #f3f1f1;
            height: 25px !important;
            padding: 0 !important;
        `,
    },
    dataTableCellLabelStyle: {
        css: css`
            border: none;
            background-color: #f3f1f1;
            height: 25px !important;
            padding: 0 !important;
            font-weight: bold;
        `,
    },
};

const styles = pageTitleStyles;

const ProductDetailsPartNumbers: React.FC<Props> = ({ product }) => {
    if (!product || !product.brand || !product.detail) {
        return null;
    }

    return (
        <StyledWrapper>
            <DataTable>
                <DataTableBody >
                    <DataTableRow>
                        <DataTableCell {...styles.dataTableCellLabelStyle}>{translate("Brand")}</DataTableCell>
                        <DataTableCell {...styles.dataTableCellStyle}>{product.brand.name}</DataTableCell>
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableCell {...styles.dataTableCellLabelStyle}>{translate("MFR Part No")}</DataTableCell>
                        <DataTableCell {...styles.dataTableCellStyle}>{product.manufacturerItem}</DataTableCell>   
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableCell {...styles.dataTableCellLabelStyle}>{translate("Part Number")}</DataTableCell>
                        <DataTableCell {...styles.dataTableCellStyle}>{product.productNumber}</DataTableCell>
                    </DataTableRow>
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumbers),
    definition: {
        displayName: "Part Numbers",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
